var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-popover',{ref:"popover",attrs:{"reference":_vm.reference,"placement":"top","trigger":"hover"},on:{"show":_vm.onShow,"after-leave":_vm.onAfterLeave,"after-enter":_vm.onAfterEnter}},[_c('div',{staticClass:"overflow-content"},[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }